export default __webpack_public_path__ + "static/media/trash.bda5c2bd.svg";